var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaxtonLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 237.348,
    height: 67.443,
    viewBox: "0 0 237.348 67.443",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Paxton_logo_",
    "data-name": "Paxton logo ",
    transform: "translate(-116.898 -270)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6535",
    "data-name": "Path 6535",
    d: "M39.006,67.456,19.532,33.734.066.013H77.94L58.473,33.734,39.006,67.456Z",
    transform: "translate(116.832 269.987)",
    fill: "#56aa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10389",
    "data-name": "Path 10389",
    d: "M733.173,150.618a58.946,58.946,0,0,1,9.765-.76c5.028,0,8.713,1.17,11.052,3.275a10.6,10.6,0,0,1,3.45,8.245A11.6,11.6,0,0,1,754.4,169.8c-2.69,2.865-7.075,4.327-12.046,4.327a17.516,17.516,0,0,1-4.094-.35v15.788h-5.087Zm5.087,19a17.066,17.066,0,0,0,4.211.408c6.139,0,9.882-2.982,9.882-8.419,0-5.2-3.684-7.719-9.3-7.719a21.35,21.35,0,0,0-4.8.409Z",
    transform: "translate(-539.565 136.804)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10390",
    "data-name": "Path 10390",
    d: "M785.967,184.164a39.833,39.833,0,0,0,.468,6.783h-4.678l-.409-3.566h-.175a10.542,10.542,0,0,1-8.654,4.21c-5.73,0-8.654-4.035-8.654-8.128,0-6.842,6.082-10.585,17.016-10.526v-.585c0-2.339-.643-6.549-6.432-6.549a14.1,14.1,0,0,0-7.367,2.105l-1.17-3.392a17.568,17.568,0,0,1,9.3-2.515c8.654,0,10.759,5.906,10.759,11.578ZM781,176.5c-5.613-.117-11.987.877-11.987,6.374a4.554,4.554,0,0,0,4.854,4.911,7.04,7.04,0,0,0,6.841-4.736,5.37,5.37,0,0,0,.293-1.637Z",
    transform: "translate(-543.063 135.421)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10391",
    "data-name": "Path 10391",
    d: "M800.092,162.727l4.035,6.081c1.052,1.58,1.93,3.041,2.865,4.62h.176c.935-1.7,1.87-3.157,2.806-4.677l3.977-6.023H819.5l-9.648,13.683,9.941,14.619H813.95l-4.152-6.373c-1.111-1.637-2.047-3.216-3.04-4.912h-.118c-.935,1.754-1.929,3.216-2.982,4.912l-4.094,6.373h-5.672l10.057-14.443-9.59-13.859Z",
    transform: "translate(-546.485 135.338)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10392",
    "data-name": "Path 10392",
    d: "M835.382,155.072v6.783h7.367v3.918h-7.367v15.262c0,3.508.994,5.5,3.86,5.5a9.63,9.63,0,0,0,2.982-.35l.234,3.859a12.392,12.392,0,0,1-4.56.76,7.16,7.16,0,0,1-5.555-2.222c-1.462-1.52-1.988-4.035-1.988-7.367V165.773h-4.386v-3.918h4.386v-5.2Z",
    transform: "translate(-550.14 136.21)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10393",
    "data-name": "Path 10393",
    d: "M876.4,176.562c0,10.466-7.25,15.027-14.092,15.027-7.66,0-13.566-5.613-13.566-14.56,0-9.473,6.2-15.028,14.033-15.028C870.9,162,876.4,167.907,876.4,176.562Zm-22.454.292c0,6.2,3.567,10.875,8.6,10.875,4.912,0,8.6-4.619,8.6-10.992,0-4.8-2.4-10.877-8.479-10.877S853.942,171.474,853.942,176.855Z",
    transform: "translate(-552.735 135.421)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10394",
    "data-name": "Path 10394",
    d: "M887.251,170.3c0-2.924-.058-5.322-.233-7.661h4.56l.292,4.677h.117A10.407,10.407,0,0,1,901.343,162c3.917,0,10,2.339,10,12.046v16.9H906.2V174.632c0-4.561-1.7-8.362-6.55-8.362a7.312,7.312,0,0,0-6.9,5.262,7.423,7.423,0,0,0-.35,2.4v17.016h-5.146Z",
    transform: "translate(-557.097 135.421)",
    fill: "#4b4b4b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaxtonLogo);
export default __webpack_public_path__ + "static/media/paxton-logo.7b808d89033a5f4ed5cc5cb09d9f7a24.svg";
export { ForwardRef as ReactComponent };